import store from 'store.js';

import { FEATURE_FLAGS } from 'constants/featureFlags';
import { isMobileView } from 'constants/isMobileView';
import { isNetchexLogin } from 'constants/netChexConstants';

import { selectEnabledFeatureFlags } from 'selectors/enabledFeatureFlags';
import { selectMSTeamsContext } from 'selectors/msTeamsSelector';

const isMsTeamsVisitor = () => selectMSTeamsContext(store.getState());

const isFeatureFlagActive = (flagKey) => FEATURE_FLAGS?.[flagKey]?.isActive;

const isFeatureFlagActiveNewKeyFormat = (flagObj) => flagObj?.isActive;

const checkSampleEngagementTemplatesEnabled = () => {
  if (FEATURE_FLAGS.SAMPLE_ENGAGEMENT_TEMPLATE.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.SAMPLE_ENGAGEMENT_TEMPLATE.key}. This shouldn't have happened.`
    );
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.SAMPLE_ENGAGEMENT_TEMPLATE.key))
    return isFeatureFlagActive(FEATURE_FLAGS.SAMPLE_ENGAGEMENT_TEMPLATE.key);

  return false;
};

const checkMeshRecommendationsEnabled = () => {
  if (FEATURE_FLAGS.MESH_RECOMMENDATION.isRetired) {
    console.warn(`Calling a retired flag ${FEATURE_FLAGS.MESH_RECOMMENDATION.key}. This shouldn't have happened.`);
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.MESH_RECOMMENDATION.key))
    return isFeatureFlagActive(FEATURE_FLAGS.MESH_RECOMMENDATION.key);

  return false;
};

const checkOKRViewIsEnabled = () => {
  if (FEATURE_FLAGS.OKR_VIEW.isRetired) {
    console.warn(`Calling a retired flag ${FEATURE_FLAGS.OKR_VIEW.key}. This shouldn't have happened.`);
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.OKR_VIEW.key)) return isFeatureFlagActive(FEATURE_FLAGS.OKR_VIEW.key);

  return false;
};

const checkAIReviewCommentsEnabled = () => {
  if (FEATURE_FLAGS.ENABLE_AI_REVIEW_COMMENTS.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_AI_REVIEW_COMMENTS.key}. This shouldn't have happened.`
    );
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_AI_REVIEW_COMMENTS.key))
    return isFeatureFlagActive(FEATURE_FLAGS.ENABLE_AI_REVIEW_COMMENTS.key);

  return false;
};

const checkAIReviewManagerSummaryEnabled = () => {
  // return false;
  if (FEATURE_FLAGS.ENABLE_AI_REVIEW_MANAGER_SUMMARY.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_AI_REVIEW_MANAGER_SUMMARY.key}. This shouldn't have happened.`
    );
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_AI_REVIEW_MANAGER_SUMMARY.key))
    return isFeatureFlagActive(FEATURE_FLAGS.ENABLE_AI_REVIEW_MANAGER_SUMMARY.key);

  return false;
};

const check1on1V2Enabled = () => {
  if (FEATURE_FLAGS.ONE_ON_ONE_V2.isRetired) {
    console.warn(`Calling a retired flag ${FEATURE_FLAGS.ONE_ON_ONE_V2.key}. This shouldn't have happened.`);
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ONE_ON_ONE_V2.key))
    return isFeatureFlagActive(FEATURE_FLAGS.ONE_ON_ONE_V2.key);

  return false;
};

const check1on1V2EventAgendaEnabled = () => {
  if (FEATURE_FLAGS.ONE_ON_ONE_V2_EVENT_AGENDA.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ONE_ON_ONE_V2_EVENT_AGENDA.key}. This shouldn't have happened.`
    );
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ONE_ON_ONE_V2_EVENT_AGENDA.key))
    return isFeatureFlagActive(FEATURE_FLAGS.ONE_ON_ONE_V2_EVENT_AGENDA.key);

  return false;
};

const checkGoalGenAIEnabled = () => {
  /* short-circuiting to enable in development */

  if (FEATURE_FLAGS.GOAL_GEN_AI.isRetired) {
    console.warn(`Calling a retired flag ${FEATURE_FLAGS.GOAL_GEN_AI.key}. This shouldn't have happened.`);
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState());

  if (enabledFeatures.includes(FEATURE_FLAGS.GOAL_GEN_AI.key))
    return isFeatureFlagActive(FEATURE_FLAGS.GOAL_GEN_AI.key);

  return false;
};

const check1on1TranscriptionEnabled = () => {
  if (FEATURE_FLAGS.ONE_ON_ONE_TRANSCRIPTION.isRetired) {
    console.warn(`Calling a retired flag ${FEATURE_FLAGS.ONE_ON_ONE_TRANSCRIPTION.key}. This shouldn't have happened.`);
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ONE_ON_ONE_TRANSCRIPTION.key))
    return isFeatureFlagActive(FEATURE_FLAGS.ONE_ON_ONE_TRANSCRIPTION.key);

  return false;
};

const checkOneOnOneMLEnabled = () => {
  if (FEATURE_FLAGS.ONE_ON_ONE_V2_ML.isRetired) {
    console.warn(`Calling a retired flag ${FEATURE_FLAGS.ONE_ON_ONE_V2_ML.key}. This shouldn't have happened.`);
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ONE_ON_ONE_V2_ML.key))
    return isFeatureFlagActive(FEATURE_FLAGS.ONE_ON_ONE_V2_ML.key);

  return false;
};

const checkCFGenAIEnabled = () => {
  // return true;

  if (FEATURE_FLAGS.CF_GEN_AI.isRetired) {
    console.warn(`Calling a retired flag ${FEATURE_FLAGS.CF_GEN_AI.key}. This shouldn't have happened.`);
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.CF_GEN_AI.key)) return isFeatureFlagActive(FEATURE_FLAGS.CF_GEN_AI.key);

  return false;
};

// the flag NEW_NAV is already retired, but there's additional logic here,
// to show rabbit code(return false) if it's a MS teams visitor or non netchex client mobile user
const checkNewNavEnabled = () => {
  if (isMsTeamsVisitor() || (!isNetchexLogin && isMobileView())) {
    return false;
  }
  return true;
};

const checkVisierAnalyticsEnabled = () => {
  if (FEATURE_FLAGS.VISIER_ANALYTICS.isRetired) {
    console.warn(`Calling a retired flag ${FEATURE_FLAGS.VISIER_ANALYTICS.key}. This shouldn't have happened.`);
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.VISIER_ANALYTICS.key) && checkNewNavEnabled())
    return isFeatureFlagActive(FEATURE_FLAGS.VISIER_ANALYTICS.key);

  return false;
};

const checkDenyPublicCFVisibilityEnabled = () => {
  if (FEATURE_FLAGS.DENY_PUBLIC_CF_VISIBILITY.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.DENY_PUBLIC_CF_VISIBILITY.key}. This shouldn't have happened.`
    );
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.DENY_PUBLIC_CF_VISIBILITY.key))
    return isFeatureFlagActive(FEATURE_FLAGS.DENY_PUBLIC_CF_VISIBILITY.key);

  return false;
};

const checkNewStaticDataFeaturesEnabled = () => {
  if (FEATURE_FLAGS.RELEASE_NEW_NAV_STATIC_DATA_FEATURES.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.RELEASE_NEW_NAV_STATIC_DATA_FEATURES.key}. This shouldn't have happened.`
    );
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.RELEASE_NEW_NAV_STATIC_DATA_FEATURES.key))
    // isFeatureFlagActiveNewKeyFormat function is used here for comparison of the new key provided  by launch darkly
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.RELEASE_NEW_NAV_STATIC_DATA_FEATURES);

  return false;
};

const checkSandboxStaticDataFeaturesEnabled = () => {
  if (FEATURE_FLAGS.RELEASE_SANDBOX_STATIC_DATA_FEATURES.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.RELEASE_SANDBOX_STATIC_DATA_FEATURES.key}. This shouldn't have happened.`
    );
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.RELEASE_SANDBOX_STATIC_DATA_FEATURES.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.RELEASE_SANDBOX_STATIC_DATA_FEATURES);

  return false;
};

const checkVisierReportsEnabled = () => {
  if (FEATURE_FLAGS.RELEASE_VISIER_REPORTS.isRetired) {
    console.warn(`Calling a retired flag ${FEATURE_FLAGS.RELEASE_VISIER_REPORTS.key}. This shouldn't have happened.`);
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.RELEASE_VISIER_REPORTS.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.RELEASE_VISIER_REPORTS);

  return false;
};

const checkOverviewExplanationsEnabled = () => {
  if (FEATURE_FLAGS.OVERVIEW_EXPLANATIONS.isRetired) {
    console.warn(`Calling a retired flag ${FEATURE_FLAGS.OVERVIEW_EXPLANATIONS.key}. This shouldn't have happened.`);
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.OVERVIEW_EXPLANATIONS.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.OVERVIEW_EXPLANATIONS);

  return false;
};

const checkOverviewReviewsExplanationsEnabled = () => {
  if (FEATURE_FLAGS.OVERVIEW_REVIEWS_EXPLANATIONS.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.OVERVIEW_REVIEWS_EXPLANATIONS.key}. This shouldn't have happened.`
    );
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.OVERVIEW_REVIEWS_EXPLANATIONS.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.OVERVIEW_REVIEWS_EXPLANATIONS);

  return false;
};

const checkLifecycleInsightsEnabled = () => {
  if (FEATURE_FLAGS.LIFECYCLE_INSIGHTS.isRetired) {
    console.warn(`Calling a retired flag ${FEATURE_FLAGS.LIFECYCLE_INSIGHTS.key}. This shouldn't have happened.`);
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.LIFECYCLE_INSIGHTS.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.LIFECYCLE_INSIGHTS);

  return false;
};

const checkActionPlanFeatureEnabled = () => {
  if (FEATURE_FLAGS.REVIEW_ACTION_PLAN.isRetired) {
    console.warn(`Calling a retired flag ${FEATURE_FLAGS.REVIEW_ACTION_PLAN.key}. This shouldn't have happened.`);
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.REVIEW_ACTION_PLAN.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.REVIEW_ACTION_PLAN);

  return false;
};

const checkEmployeePersonaReviewReport = () => {
  if (FEATURE_FLAGS.EMPLOYEE_PERSONA_REVIEW_REPORT.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.EMPLOYEE_PERSONA_REVIEW_REPORT.key}. This shouldn't have happened.`
    );
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.EMPLOYEE_PERSONA_REVIEW_REPORT.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.EMPLOYEE_PERSONA_REVIEW_REPORT);

  return false;
};

const checkDemoAICalibrationEnabled = () => {
  if (FEATURE_FLAGS.DEMO_AI_CALIBRATION.isRetired) {
    console.warn(`Calling a retired flag ${FEATURE_FLAGS.DEMO_AI_CALIBRATION.key}. This shouldn't have happened.`);
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.DEMO_AI_CALIBRATION.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.DEMO_AI_CALIBRATION);

  return false;
};

const checkSettingsPageRevampEnabled = () => {
  if (FEATURE_FLAGS.RELEASE_SETTINGS_PAGE_REVAMP.isRetired) {
    // console.warn(
    //   `Calling a retired flag ${FEATURE_FLAGS.RELEASE_SETTINGS_PAGE_REVAMP.key}. This shouldn't have happened.`
    // );
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.RELEASE_SETTINGS_PAGE_REVAMP.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.RELEASE_SETTINGS_PAGE_REVAMP);

  return false;
};

const checkDemoPredictiveScoreEnabled = () => {
  if (FEATURE_FLAGS.DEMO_PREDICTIVE_SCORE_OFF_CYCLE.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.DEMO_PREDICTIVE_SCORE_OFF_CYCLE.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.DEMO_PREDICTIVE_SCORE_OFF_CYCLE.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.DEMO_PREDICTIVE_SCORE_OFF_CYCLE);

  return false;
};

const checkFeedbackInclusionEnabled = () => {
  if (FEATURE_FLAGS.RELEASE_FEEDBACK_INCLUSION.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.RELEASE_FEEDBACK_INCLUSION.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.RELEASE_FEEDBACK_INCLUSION.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.RELEASE_FEEDBACK_INCLUSION);

  return false;
};

const checkDemoReviewCreationTriggeredReviewsEnabled = () => {
  if (FEATURE_FLAGS.DEMO_REVIEW_CREATION_TRIGGERED_REVIEWS.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.DEMO_REVIEW_CREATION_TRIGGERED_REVIEWS.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.DEMO_REVIEW_CREATION_TRIGGERED_REVIEWS.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.DEMO_REVIEW_CREATION_TRIGGERED_REVIEWS);

  return false;
};

const checkReviewMobileFeedbackTypeEnabled = () => {
  if (FEATURE_FLAGS.RELEASE_REVIEW_MOBILE_FEEDBACK_TYPE.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.RELEASE_REVIEW_MOBILE_FEEDBACK_TYPE.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.RELEASE_REVIEW_MOBILE_FEEDBACK_TYPE.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.RELEASE_REVIEW_MOBILE_FEEDBACK_TYPE);

  return false;
};

const checkSettingsRevampEmployeeRosterEnabled = () => {
  if (FEATURE_FLAGS.ENABLE_SETTINGS_REVAMP_EMPLOYEE_ROSTER.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_SETTINGS_REVAMP_EMPLOYEE_ROSTER.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_SETTINGS_REVAMP_EMPLOYEE_ROSTER.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_SETTINGS_REVAMP_EMPLOYEE_ROSTER);

  return false;
};

const checkReviewsOverviewBoxGridEnabled = () => {
  if (FEATURE_FLAGS.RELEASE_REVIEWS_OVERVIEW_BOX_GRID.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.RELEASE_REVIEWS_OVERVIEW_BOX_GRID.key}. This shouldn't have happened.`
    );
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.RELEASE_REVIEWS_OVERVIEW_BOX_GRID.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.RELEASE_REVIEWS_OVERVIEW_BOX_GRID);

  return false;
};

const checkReviewViewBasedFilterEnabled = () => {
  if (FEATURE_FLAGS.ENABLE_REVIEW_VIEW_BASED_FILTER.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_REVIEW_VIEW_BASED_FILTER.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_REVIEW_VIEW_BASED_FILTER.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_REVIEW_VIEW_BASED_FILTER);

  return false;
};

const checkHideDemoOneOnOneSections = () => {
  if (FEATURE_FLAGS.HIDE_DEMO_ONE_ON_ONE_SECTIONS.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.HIDE_DEMO_ONE_ON_ONE_SECTIONS.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.HIDE_DEMO_ONE_ON_ONE_SECTIONS.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.HIDE_DEMO_ONE_ON_ONE_SECTIONS);

  return false;
};

const checkDisableInitiativesOptionMobileSite = () => {
  if (FEATURE_FLAGS.DISABLE_INITIATIVES_MOBILE_SITE.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.DISABLE_INITIATIVES_MOBILE_SITE.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.DISABLE_INITIATIVES_MOBILE_SITE.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.DISABLE_INITIATIVES_MOBILE_SITE);

  return false;
};

const checkEnableCompanySupport = () => {
  if (FEATURE_FLAGS.ENABLE_COMPANY_SUPPORT.isRetired) {
    console.warn(`Calling a retired flag ${FEATURE_FLAGS.ENABLE_COMPANY_SUPPORT.key}. This shouldn't have happened.`);
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_COMPANY_SUPPORT.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_COMPANY_SUPPORT);

  return false;
};

const checkCalibrationPrivateCommentsEnabled = () => {
  if (FEATURE_FLAGS.ENABLE_CALIBRATION_PRIVATE_COMMENTS.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_CALIBRATION_PRIVATE_COMMENTS.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_CALIBRATION_PRIVATE_COMMENTS.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_CALIBRATION_PRIVATE_COMMENTS);

  return false;
};

const checkReviewReportsEnabled = () => {
  if (FEATURE_FLAGS.ENABLE_REVIEW_REPORTS.isRetired) {
    console.warn(`Calling a retired flag ${FEATURE_FLAGS.ENABLE_REVIEW_REPORTS.key}. This shouldn't have happened.`);
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];
  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_REVIEW_REPORTS.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_REVIEW_REPORTS);
  return false;
};

const checkShowExternalEmployeeId = () => {
  if (FEATURE_FLAGS.SHOW_EXTERNAL_EMPLOYEE_ID.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.SHOW_EXTERNAL_EMPLOYEE_ID.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.SHOW_EXTERNAL_EMPLOYEE_ID.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.SHOW_EXTERNAL_EMPLOYEE_ID);

  return false;
};

const checkEnableSurveyPresetsAndRecurrence = () => {
  if (FEATURE_FLAGS.ENABLE_SURVEY_PRESET_RECURRENCE.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_SURVEY_PRESET_RECURRENCE.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_SURVEY_PRESET_RECURRENCE.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_SURVEY_PRESET_RECURRENCE);

  return false;
};

// TODO: Remove this once the feature flag is fully launched after the 10th of June 2025
const checkGoalDataExportsReportEnabled = () => {
  if (FEATURE_FLAGS.ENABLE_GOAL_DATA_REPORTS_EXPORT.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_GOAL_DATA_REPORTS_EXPORT.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_GOAL_DATA_REPORTS_EXPORT.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_GOAL_DATA_REPORTS_EXPORT);

  return false;
};

const checkSimplifiedReviewCreationEnabled = () => {
  if (FEATURE_FLAGS.ENABLE_SIMPLIFIED_REVIEW_CREATION.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_SIMPLIFIED_REVIEW_CREATION.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_SIMPLIFIED_REVIEW_CREATION.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_SIMPLIFIED_REVIEW_CREATION);

  return false;
};

const checkEnableESignReviewReport = () => {
  if (FEATURE_FLAGS.ENABLE_ESIGN_REVIEW_REPORT.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_ESIGN_REVIEW_REPORT.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_ESIGN_REVIEW_REPORT.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_ESIGN_REVIEW_REPORT);

  return false;
};

const checkCompensationModuleFeatureFlagEnabled = () => {
  if (FEATURE_FLAGS.ENABLE_COMPENSATION_MODULE.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_COMPENSATION_MODULE.key}. This shouldn't have happened.`
    );
    return true;
  }

  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_COMPENSATION_MODULE.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_COMPENSATION_MODULE);

  return false;
};

const checkReviewInclusionEnabled = () => {
  if (FEATURE_FLAGS.RELEASE_REVIEW_INCLUSION.isRetired) {
    console.warn(`Calling a retired flag ${FEATURE_FLAGS.RELEASE_REVIEW_INCLUSION.key}. This shouldn't have happened.`);
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.RELEASE_REVIEW_INCLUSION.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.RELEASE_REVIEW_INCLUSION);

  return false;
};

const checkDisciplinaryActionGenAIEnabled = () => {
  if (FEATURE_FLAGS.DISCIPLINARY_ACTION_GEN_AI.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.DISCIPLINARY_ACTION_GEN_AI.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.DISCIPLINARY_ACTION_GEN_AI.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.DISCIPLINARY_ACTION_GEN_AI);

  return false;
};

const checkStaticDataCompensationEnabled = () => {
  if (FEATURE_FLAGS.ENABLE_STATIC_DATA_COMPENSATION.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_STATIC_DATA_COMPENSATION.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_STATIC_DATA_COMPENSATION.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_STATIC_DATA_COMPENSATION);

  return false;
};

const checkShowDynamicCompensationBudgetEnabled = () => {
  if (FEATURE_FLAGS.ENABLE_SHOW_DYNAMIC_COMPENSATION_BUDGET.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_SHOW_DYNAMIC_COMPENSATION_BUDGET.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_SHOW_DYNAMIC_COMPENSATION_BUDGET.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_SHOW_DYNAMIC_COMPENSATION_BUDGET);

  return false;
};

const checkEnabledSimplifiedReviewDemoPresets = () => {
  if (FEATURE_FLAGS.ENABLE_SIMPLIFIED_REVIEW_DEMO_PRESETS.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_SIMPLIFIED_REVIEW_DEMO_PRESETS.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_SIMPLIFIED_REVIEW_DEMO_PRESETS.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_SIMPLIFIED_REVIEW_DEMO_PRESETS);

  return false;
};

const checkEnabledMockDemoPointsModule = () => {
  if (FEATURE_FLAGS.ENABLE_MOCK_DEMO_POINTS_MODULE.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_MOCK_DEMO_POINTS_MODULE.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_MOCK_DEMO_POINTS_MODULE.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_MOCK_DEMO_POINTS_MODULE);

  return false;
};

const checkEnabledApiIntegratedRewardsModule = () => {
  if (FEATURE_FLAGS.ENABLE_API_INTEGRATED_REWARDS_MODULE.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_API_INTEGRATED_REWARDS_MODULE.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_API_INTEGRATED_REWARDS_MODULE.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_API_INTEGRATED_REWARDS_MODULE);

  return false;
};

const checkEnabledStaticRewardsModule = () => {
  // API-integrated flag takes precedence — if it's on, static demo is disabled
  if (checkEnabledApiIntegratedRewardsModule()) return false;

  if (FEATURE_FLAGS.ENABLE_STATIC_REWARDS_MODULE.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_STATIC_REWARDS_MODULE.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_STATIC_REWARDS_MODULE.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_STATIC_REWARDS_MODULE);

  return false;
};

const checkEnabledProbationCheckinReview = () => {
  if (FEATURE_FLAGS.ENABLE_PROBATION_CHECKIN_REVIEW.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_PROBATION_CHECKIN_REVIEW.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_PROBATION_CHECKIN_REVIEW.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_PROBATION_CHECKIN_REVIEW);

  return false;
};

const checkEnabledShowCompensationAnomalies = () => {
  if (FEATURE_FLAGS.ENABLE_SHOW_COMPENSATION_ANOMALIES.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_SHOW_COMPENSATION_ANOMALIES.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_SHOW_COMPENSATION_ANOMALIES.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_SHOW_COMPENSATION_ANOMALIES);

  return false;
};

const checkEnabledShowFunctionRoleSpecificCompetencies = () => {
  if (FEATURE_FLAGS.ENABLE_SHOW_FUNCTION_ROLE_SPECIFIC_COMPETENCIES.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_SHOW_FUNCTION_ROLE_SPECIFIC_COMPETENCIES.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_SHOW_FUNCTION_ROLE_SPECIFIC_COMPETENCIES.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_SHOW_FUNCTION_ROLE_SPECIFIC_COMPETENCIES);

  return false;
};

const checkEnabledUploadDocumentsToDocumentCenter = () => {
  if (FEATURE_FLAGS.ENABLE_UPLOAD_DOCUMENTS_TO_DOCUMENT_CENTER.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_UPLOAD_DOCUMENTS_TO_DOCUMENT_CENTER.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_UPLOAD_DOCUMENTS_TO_DOCUMENT_CENTER.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_UPLOAD_DOCUMENTS_TO_DOCUMENT_CENTER);

  return false;
};

const checkEnabledShowAssignFinalReviewer = () => {
  if (FEATURE_FLAGS.ENABLE_SHOW_ASSIGN_FINAL_REVIEWER.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_SHOW_ASSIGN_FINAL_REVIEWER.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_SHOW_ASSIGN_FINAL_REVIEWER.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_SHOW_ASSIGN_FINAL_REVIEWER);

  return false;
};

const checkEnabledFinalReviewerNomenclature = () => {
  if (FEATURE_FLAGS.ENABLE_FINAL_REVIEWER_NOMENCLATURE.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_FINAL_REVIEWER_NOMENCLATURE.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_FINAL_REVIEWER_NOMENCLATURE.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_FINAL_REVIEWER_NOMENCLATURE);

  return false;
};

const checkEnabledReviewsGoalWeightageReport = () => {
  if (FEATURE_FLAGS.ENABLE_REVIEWS_GOAL_WEIGHTAGE_REPORT.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_REVIEWS_GOAL_WEIGHTAGE_REPORT.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_REVIEWS_GOAL_WEIGHTAGE_REPORT.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_REVIEWS_GOAL_WEIGHTAGE_REPORT);

  return false;
};

const checkEnabledCompensationBonus = () => {
  if (FEATURE_FLAGS.ENABLE_COMPENSATION_BONUS.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_COMPENSATION_BONUS.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_COMPENSATION_BONUS.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_COMPENSATION_BONUS);

  return false;
};

const checkUseLegacyReviewReopenFlow = () => {
  if (FEATURE_FLAGS.USE_LEGACY_REVIEW_REOPEN_FLOW.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.USE_LEGACY_REVIEW_REOPEN_FLOW.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.USE_LEGACY_REVIEW_REOPEN_FLOW.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.USE_LEGACY_REVIEW_REOPEN_FLOW);

  return false;
};

const checkEnableNewSurveyReports = () => {
  if (FEATURE_FLAGS.ENABLE_NEW_SURVEY_REPORTS.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_NEW_SURVEY_REPORTS.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_NEW_SURVEY_REPORTS.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_NEW_SURVEY_REPORTS);

  return false;
};

const checkEnableCompensationLetterDownload = () => {
  if (FEATURE_FLAGS.ENABLE_COMPENSATION_LETTER_DOWNLOAD.isRetired) {
    console.warn(
      `Calling a retired flag ${FEATURE_FLAGS.ENABLE_COMPENSATION_LETTER_DOWNLOAD.key}. This shouldn't have happened.`
    );
    return true;
  }
  const enabledFeatures = selectEnabledFeatureFlags(store.getState()) ?? [];

  if (enabledFeatures.includes(FEATURE_FLAGS.ENABLE_COMPENSATION_LETTER_DOWNLOAD.key))
    return isFeatureFlagActiveNewKeyFormat(FEATURE_FLAGS.ENABLE_COMPENSATION_LETTER_DOWNLOAD);

  return false;
};

export {
  checkSampleEngagementTemplatesEnabled,
  checkMeshRecommendationsEnabled,
  checkOKRViewIsEnabled,
  checkAIReviewCommentsEnabled,
  checkAIReviewManagerSummaryEnabled,
  check1on1V2Enabled,
  check1on1V2EventAgendaEnabled,
  check1on1TranscriptionEnabled,
  checkGoalGenAIEnabled,
  checkOneOnOneMLEnabled,
  checkCFGenAIEnabled,
  checkVisierAnalyticsEnabled,
  checkNewNavEnabled,
  checkDenyPublicCFVisibilityEnabled,
  checkNewStaticDataFeaturesEnabled,
  checkSandboxStaticDataFeaturesEnabled,
  checkVisierReportsEnabled,
  checkReviewsOverviewBoxGridEnabled,
  checkOverviewExplanationsEnabled,
  checkActionPlanFeatureEnabled,
  checkOverviewReviewsExplanationsEnabled,
  checkEmployeePersonaReviewReport,
  checkLifecycleInsightsEnabled,
  checkDemoAICalibrationEnabled,
  checkSettingsPageRevampEnabled,
  checkDemoPredictiveScoreEnabled,
  checkFeedbackInclusionEnabled,
  checkDemoReviewCreationTriggeredReviewsEnabled,
  checkReviewMobileFeedbackTypeEnabled,
  checkSettingsRevampEmployeeRosterEnabled,
  checkReviewViewBasedFilterEnabled,
  checkHideDemoOneOnOneSections,
  checkDisableInitiativesOptionMobileSite,
  checkCalibrationPrivateCommentsEnabled,
  checkEnableCompanySupport,
  checkReviewReportsEnabled,
  checkShowExternalEmployeeId,
  checkEnableSurveyPresetsAndRecurrence,
  checkGoalDataExportsReportEnabled,
  checkSimplifiedReviewCreationEnabled,
  checkEnableESignReviewReport,
  checkCompensationModuleFeatureFlagEnabled,
  checkReviewInclusionEnabled,
  checkDisciplinaryActionGenAIEnabled,
  checkStaticDataCompensationEnabled,
  checkShowDynamicCompensationBudgetEnabled,
  checkEnabledSimplifiedReviewDemoPresets,
  checkEnabledMockDemoPointsModule,
  checkEnabledStaticRewardsModule,
  checkEnabledApiIntegratedRewardsModule,
  checkEnabledProbationCheckinReview,
  checkEnabledShowCompensationAnomalies,
  checkEnabledShowFunctionRoleSpecificCompetencies,
  checkEnabledUploadDocumentsToDocumentCenter,
  checkEnabledShowAssignFinalReviewer,
  checkEnabledFinalReviewerNomenclature,
  checkEnabledReviewsGoalWeightageReport,
  checkEnabledCompensationBonus,
  checkUseLegacyReviewReopenFlow,
  checkEnableNewSurveyReports,
  checkEnableCompensationLetterDownload,
};
